/** 컬럼 autoFit에 사용되는 임계점 */
export const THRESHOLD = 1.1;

export const ROW_HEIGHT = 26;
export const SCROLLBAR_WIDTH = 10;
export const BUTTON_SIZE = 0;
export const MIN_SCROLLBAR_HANDLE_SIZE = 60;

// 셀 관련 상수
export const CELL_PADDING = 8;

// 화살표 박스 관련 상수
export const ARROW_BOX_PADDING_RIGHT = 4;
export const ARROW_BOX_WIDTH = 18;
export const ARROW_BOX_PADDING = 4;
export const ARROW_SIZE = 6;

export const FONT_FAMILY = 'Dotumche, sans-serif';
export const FONT_SIZE = '10px';
export const FONT = `${FONT_SIZE} ${FONT_FAMILY}`;

export const CHECKBOX_SIZE = 13;

interface TableStyles {
    // 테이블 기본 스타일
    TABLE_BACKGROUND_COLOR: string;
    ACTIVE_BORDER: string;
    
    // 컬럼 관련 스타일
    COLUMN_FONT: string;
    COLUMN_STROKE_COLOR: string;
    COLUMN_BACKGROUND_COLOR: string;
    COLUMN_TEXT_COLOR: string;
    SORT_ICON_FONT: string;
    SUMMARY_COLUMN_BACKGROUND_COLOR: string;
    
    // 셀 관련 스타일
    CELL_FONT: string;
    CELL_TEXT_COLOR: string;
    CELL_BACKGROUND_COLOR: string;
    CELL_STROKE_COLOR: string;
    CELL_SELECTED_BACKGROUND_COLOR: string;
    CELL_SELECTED_STROKE_COLOR: string;
    
    // 체크박스 관련 스타일
    CHECKBOX_FILL: string;
    CHECKBOX_STROKE: string;
    CHECKMARK: string;
    CELL_CHECKBOX_BACKGROUND_COLOR: string;
    CELL_CHECKBOX_STROKE_COLOR: string;
    
    // 행 선택 관련 스타일
    ROW_SELECTED_BACKGROUND_COLOR: string;
    
    // 스크롤바 관련 스타일
    SCROLLBAR_BACKGROUND: string;
    SCROLLBAR_ARROW: string;
    SCROLLBAR_HANDLE: string;
    SCROLLBAR_BORDER: string;

    // 화살표 박스 관련 스타일
    ARROW_BOX_BACKGROUND_COLOR: string;
    ARROW_BOX_STROKE_COLOR: string;
    ARROW_COLOR: string;
}

const TableStyle: TableStyles = {
    // 테이블 기본 스타일
    TABLE_BACKGROUND_COLOR: "#FFFFFF",
    ACTIVE_BORDER: "#aaaae6",
    
    // 컬럼 관련 스타일
    COLUMN_FONT: "100 12px Dotumche, sans-serif",
    COLUMN_STROKE_COLOR: "#E0E0F0",
    COLUMN_BACKGROUND_COLOR: "#F0F0F4",
    COLUMN_TEXT_COLOR: "#000000",
    SORT_ICON_FONT: "100 10px Dotumche, sans-serif",
    SUMMARY_COLUMN_BACKGROUND_COLOR: "#F0F0F4",
    
    // 셀 관련 스타일
    CELL_FONT: "100 12px Dotumche, sans-serif",
    CELL_TEXT_COLOR: "#000000",
    CELL_BACKGROUND_COLOR: "#ffffff",
    CELL_STROKE_COLOR: "#E0E0F0",
    CELL_SELECTED_BACKGROUND_COLOR: "#9AA1FF60",
    CELL_SELECTED_STROKE_COLOR: "#9AA1FF",

    // 체크박스 관련 스타일
    CHECKBOX_FILL: "#FEFEFF",
    CHECKBOX_STROKE: "#D0D0E0",
    CHECKMARK: "#111111",
    CELL_CHECKBOX_BACKGROUND_COLOR: "#FEFEFF",
    CELL_CHECKBOX_STROKE_COLOR: "#D0D0E0",
    
    // 행 선택 관련 스타일
    ROW_SELECTED_BACKGROUND_COLOR: "#BCC3FF40",
    
    // 스크롤바 관련 스타일
    SCROLLBAR_BACKGROUND: "#f8f8fc",
    SCROLLBAR_ARROW: "#666",
    SCROLLBAR_HANDLE: "#e0e0e8",
    SCROLLBAR_BORDER: "#f0f0f5",
    
    // 화살표 박스 관련 스타일
    ARROW_BOX_BACKGROUND_COLOR: "#FEFEFF",
    ARROW_BOX_STROKE_COLOR: "#D0D0E0",
    ARROW_COLOR: "#000",
};

export default TableStyle;
